import { ImageState } from 'editor/src/store/gallery/types';
import { RootState } from 'editor/src/store/index';

import getGalleryImages from './getGalleryImages';

const getGalleryUploadedImagesCount = (state: RootState) =>
  getGalleryImages(state).filter((image) => image.state === ImageState.UPLOADED).length;

export default getGalleryUploadedImagesCount;
